import _ = require("underscore");
import Mediator = require("../mediator");
import Utils = require("../utils");
import Portal = require("portal-gis");
import View = require("./view");

class Control extends View {
    // input field with change notification
    // passes input to all associated 'locator' commands

    static about = `
A simple input control that puts the search _location_ on the message bus.
    `;

    static options = Utils.defaults({
        "event": {
            "default": "universal-search",
        },
        "template": {
            "default": "app/templates/universal-search-template",
        },
    }, View.options);

    static output = {
        "location": {
            "about": "The text entered by the user in the input control",
        },
    };

    execute() {
        _.defaults(this.options, {
            "event": Control.options.event.default,
            "template": Control.options.template.default,
        });
    }

    setViewOptions(options) {
        options["events"] = {
            "change": (event: JQueryEventObject) => {
                var location = (<HTMLInputElement>event.target).value;
                this.trigger({
                    location: location
                });
            }
        };
        return super.setViewOptions(options);
    }

}

export = Control; 